import { Campaign } from '@app/types/api';
import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../../utils/sportsApi';
import { CommonKey } from '../../../types/api';

const fetchCampaigns = async (clientId: number): Promise<Campaign[]> => {
    try {
        const result: any = await sportsApi
            .url(`/clients/${clientId}/social-campaigns`)
            .get()
            .json();
        
        // Check if result is a wretch request object (happens when API errors are caught)
        // sportsApi error handlers return the request object instead of throwing
        if (result && typeof result === 'object' && '_url' in result) {
            return [];
        }
        
        return result as Campaign[];
    } catch (error) {
        // Return empty array on error - notification already shown by sportsApi
        return [];
    }
};

const useCampaigns = (clientId: number, options = {}) =>
    useQuery({
        queryKey: [CommonKey.Campaigns, clientId],
        queryFn: (): Promise<Campaign[]> => fetchCampaigns(clientId),
        ...options,
    });

export default useCampaigns;
